import { Table } from '../../../../components/general/table';
import { Pqr } from '../../../../../shared/types/modules/pqr';
import { usePqrHistoryList } from './hook';
import { PqrHistoryListProps } from './props';

type PqrHistoryRow = Pqr & {
    id_pqr?: string;
    documento_cuenta?: string;
};

const resolveHistoryRowId = (row: PqrHistoryRow) =>
    row.id ?? `history-${row.id_pqr ?? row.documento_cuenta ?? 'row'}`;

export const PqrHistoryList = ({ filters }: PqrHistoryListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        usePqrHistoryList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            getRowId={(row) => resolveHistoryRowId(row as PqrHistoryRow)}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
        />
    );
};
